import { Link, useNavigate } from "react-router-dom";
import { Images, Heart } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";

export default function CollectionCard({ collection, to, showStatus = false, showOwnerLink = false }) {
  const c = collection;
  const navigate = useNavigate();
  const goCurator = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/curator/${c.owner_id}`);
  };
  return (
    <Link
      to={to}
      data-testid="collection-card-item"
      className="group block rounded-xl overflow-hidden border border-stoneline bg-white shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    >
      <div className="aspect-[4/3] bg-stone-100 overflow-hidden relative">
        {c.cover_image ? (
          <img
            src={c.cover_image}
            alt={c.title}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-stone-300">
            <Images className="h-10 w-10" />
          </div>
        )}
        <div className="absolute top-2 right-2 bg-ink/70 text-parchment text-[11px] font-semibold px-2 py-0.5 rounded-full flex items-center gap-1">
          <Images className="h-3 w-3" /> {c.items?.length || 0}
        </div>
        {c.likes > 0 && (
          <div className="absolute bottom-2 right-2 bg-parchment/90 text-brick text-[11px] font-semibold px-2 py-0.5 rounded-full flex items-center gap-1">
            <Heart className="h-3 w-3 fill-brick" /> {c.likes}
          </div>
        )}
        {showStatus && <div className="absolute top-2 left-2"><StatusBadge status={c.status} /></div>}
      </div>
      <div className="p-4">
        <h3 className="font-serif text-lg font-semibold text-ink leading-snug line-clamp-1 group-hover:text-brick transition-colors">
          {c.title}
        </h3>
        {c.description && <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{c.description}</p>}
        <div className="mt-3 flex items-center gap-2">
          {c.owner_picture && <img src={c.owner_picture} alt="" className="h-5 w-5 rounded-full object-cover" />}
          {showOwnerLink ? (
            <span onClick={goCurator} className="text-xs text-muted-foreground hover:text-brick hover:underline cursor-pointer">
              {c.owner_name}
            </span>
          ) : (
            <span className="text-xs text-muted-foreground">{c.owner_name}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
